import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/pages/Login";
import { api, errMsg } from "@/lib/api";

const BackToLogin = () => (
  <Link to="/login" className="text-sm text-emerald-700 font-medium hover:underline" data-testid="back-to-login-link">Torna all'accesso</Link>
);

export function ForgotPassword() {
  const [username, setUsername] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { username });
      setSent(true);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <AuthShell title="Password dimenticata" subtitle="Inserisci il tuo nome utente: ti invieremo un link per impostare una nuova password.">
      {sent ? (
        <div className="space-y-4" data-testid="forgot-sent"><p>Se l'utente esiste, riceverà a breve un'email con il link (valido 1 ora). Controlla anche lo spam.</p><BackToLogin /></div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div><Label>Nome utente (o email)</Label><Input required value={username} onChange={(e) => setUsername(e.target.value)} data-testid="forgot-username-input" /></div>
          <Button type="submit" className="w-full h-11 bg-[#0B192C] hover:bg-[#1E3E62]" data-testid="forgot-submit-button">Invia link di recupero</Button>
          <BackToLogin />
        </form>
      )}
    </AuthShell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const [f, setF] = useState({ password: "", confirm: "" });
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.password !== f.confirm) return toast.error("Le password non coincidono");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password: f.password });
      setDone(true);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <AuthShell title="Nuova password" subtitle="Scegli una nuova password di almeno 8 caratteri.">
      {done ? (
        <div className="space-y-4" data-testid="reset-done"><p>Password aggiornata. Per sicurezza sei stato disconnesso da tutti i dispositivi.</p><BackToLogin /></div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <div><Label>Nuova password</Label><Input type="password" required minLength={8} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="reset-password-input" /></div>
          <div><Label>Conferma password</Label><Input type="password" required minLength={8} value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="reset-confirm-input" /></div>
          <Button type="submit" className="w-full h-11 bg-emerald-600 hover:bg-emerald-700" data-testid="reset-submit-button">Salva nuova password</Button>
        </form>
      )}
    </AuthShell>
  );
}

export function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const [msg, setMsg] = useState("");
  const once = useRef(false);
  useEffect(() => {
    if (once.current) return;
    once.current = true;
    api.post("/auth/verify-email", { token: params.get("token") || "" })
      .then(() => setState("ok"))
      .catch((e) => { setMsg(errMsg(e)); setState("error"); });
  }, [params]);
  return (
    <AuthShell title="Verifica email" subtitle="Conferma del tuo indirizzo email.">
      <div className="space-y-4" data-testid="verify-email-result">
        {state === "loading" && <p>Verifica in corso…</p>}
        {state === "ok" && <p className="text-emerald-700 font-medium" data-testid="verify-email-ok">Email confermata! Ora puoi accedere all'app.</p>}
        {state === "error" && <p className="text-red-600" data-testid="verify-email-error">{msg}</p>}
        <BackToLogin />
      </div>
    </AuthShell>
  );
}
